import type { EquipQuality } from '@/types/equip'
import type { PetType } from '@/types/pet'
import type { BaseUserAttrType } from '@/types/user'

export function getPetName(monsterId: number) {
  return `👾 ${monsterNameMap[monsterId]}`
}

export function sortPetList(petList: PetType[]) {
  // 排序魔物列表
  const qualityOrder = ['antiquity', 'legend', 'unique', 'epic', 'race', 'normal']
  petList.sort((a, b) => {
    const qualityIndexA = qualityOrder.indexOf(a.quality)
    const qualityIndexB = qualityOrder.indexOf(b.quality)
    if (qualityIndexA !== qualityIndexB) {
      return qualityIndexA - qualityIndexB
    }

    const aName = monsterNameMap[a.monsterId]
    const bName = monsterNameMap[b.monsterId]
    return bName.localeCompare(aName)
  })
}

export const monsterNameMap: Record<number, string> = {
  101: '史莱姆',
  102: '石头人',
  103: '幽灵',
  104: '半人马',
  105: '行尸',
  106: '矮人',
  201: '狮鹫',
  202: '地狱犬',
  203: '水元素',
  204: '鹰身女妖',
  205: '半兽人',
  206: '石像鬼',
  207: '软泥怪',
  208: '电元素',
  301: '土元素',
  302: '吸血鬼',
  303: '恶鬼',
  304: '钢铁人',
  305: '矮人首领',
  306: '冰元素',
  307: '淤泥怪',
  308: '翡翠蜥蜴',
  309: '雷元素',
  310: '皇家狮鹫',
  401: '雷鸟',
  402: '巨蜥',
  403: '邪神',
  404: '巫妖',
  405: '牛头怪',
  406: '食人魔',
  407: '枯木守卫',
  1001: '月隐玉兔',
  1002: '黑奴aring',
  1003: '霜铃鹿',
  1004: '小马驹',
  501: '小型水晶龙-攻击',
  502: '小型水晶龙-攻速',
  503: '小型水晶龙-暴击',
  504: '小型水晶龙-爆伤',
  505: '小型水晶龙-破防',
  506: '小型水晶龙-命中',
  601: '破军铁骑',
  602: '无影疾驰',
  603: '影袭天马',
  604: '星爆神驹',
  605: '刺钢影驹',
  606: '神眼灵驹',
}

export function getFusionRate(quality: EquipQuality) {
  switch (quality) {
    case 'normal':
      return 60
    case 'race':
      return 40
    case 'epic':
      return 30
    default:
      return 0
  }
}
export function getFusionPrice(quality?: EquipQuality) {
  switch (quality) {
    case 'normal':
      return 250000
    case 'race':
      return 500000
    case 'epic':
      return 750000
    case 'legend':
      return 1000000
    default:
      return 0
  }
}
const attrRatio = {
  atk: 1,
  atksp: 0.5,
  crt: 0.5,
  crtd: 1.5,
  heat: 1.5,
  hr: 0.5,
}
export function computedTotalAttrValue(fightAttrs: Partial<BaseUserAttrType>) {
  let res = 0
  let key: keyof BaseUserAttrType
  for (key in fightAttrs) {
    res += fightAttrs[key]! / attrRatio[key]
  }
  return res
}
const qualityAttrMap: Partial<Record<EquipQuality, number>> = {
  normal: 6,
  race: 11,
  epic: 16,
  legend: 21,
  antiquity: 26,
}
export function getMaxFightAttrValue(quality: EquipQuality, rank: number) {
  return qualityAttrMap[quality]! + (rank - 1) * 2
}

const petPrice: Partial<Record<EquipQuality, number>> = {
  normal: 20000,
  race: 40000,
  epic: 80000,
  legend: 160000,
  antiquity: 320000,
}
export function getPetPrice(quality: EquipQuality) {
  return petPrice[quality] || 0
}

export function getEvolutionPrice(id?: number) {
  if (!id) return 0
  const rank = Number(id.toString().slice(0, 1))
  return 1000000 + rank * 1000000
}

export function getExciteGoldPrice(id?: number) {
  if (!id) return 0
  const rank = Number(id.toString().slice(0, 1))
  return 500000 + rank * 500000
}
export function getExciteStonePrice(id?: number) {
  if (!id) return 0
  const rank = Number(id.toString().slice(0, 1))
  return 2 + rank * 2
}
export function getExiteResValueText(value: number, petInfo: PetType) {
  const rank = Number(petInfo.monsterId.toString().slice(0, 1))
  const maxValue = getMaxFightAttrValue(petInfo.quality, rank)
  const bottomValue = maxValue > value + 0.1 ? value + 0.1 : maxValue
  if (maxValue === bottomValue) return maxValue.toFixed(1)
  const topValue = maxValue > value + 0.3 ? value + 0.3 : maxValue
  return `${(value + 0.1).toFixed(1)} ~ ${topValue.toFixed(1)}`
}
export const batchSellQualityList = [
  { name: '普通', key: 'normal' },
  { name: '稀有', key: 'race' },
  { name: '史诗', key: 'epic' },
]
